import React, { useState } from 'react'
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { IconGripVertical } from '@tabler/icons-react'
import cx from 'clsx'
import { Box, Text, Group, Button, Image, Badge, Flex, Paper } from '@mantine/core'
import { useListState } from '@mantine/hooks'
import classes from '../../../../../assets/module-css/DndProductImage.module.css'
import { useSelector } from 'react-redux'
import { adjustImageProduct } from '../../../../../services/products'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'


const SortableItem = ({ item, index }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box
      className={cx(classes.item, { [classes.itemDragging]: isDragging })}
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <div className={classes.dragHandle} {...listeners} style={{ cursor: 'grab' }}>
        <IconGripVertical size={18} stroke={1.5} />
      </div>
      <Flex gap='md' align='start'>
        <Paper shadow="sm" w='auto' withBorder radius='md'>
          <Image
            radius="md"
            h={100}
            w={100}
            fit="cover"
            src={item.source}
        />
        </Paper>
        <Box>
          <Text fz='sm' fw='500'>Position Image: {index}</Text>
          {item.is_default ? <Badge color="red" tt='capitalize'>Main Image</Badge> : ''}
        </Box>
      </Flex>
    </Box>
  );
}

const FormAdjustPositionImageProduct = ({ idProduct, dataImage, quitAdjustPosition, reloadList }) => {
  const { summary } = useSelector(state => state.product_detail)
  const [loadingAdjust, setLoadingAdjust] = useState(false)
  const [state, handlers] = useListState(dataImage)

  const handleSubmitAdjustImage = async (data) => {
    setLoadingAdjust(true)
    const recentCreator = summary.creator.id
    const remapData = data.map((val, index) => {
      return {
        id: val.id,
        position: index + 1
      }
    })

    const payload = {
      images: remapData,
      user_ids: [recentCreator]
    }
    try {
      const response = await adjustImageProduct(idProduct, payload)
      if (response.success) {
        notificationSuccess('Adjust Position Image Product Success', 'You have been successfully adjust position image product')
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError('Adjust Position Image Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingAdjust(false)
      quitAdjustPosition()
      reloadList()
    }
  }

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(KeyboardSensor)
  )

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) {
      return
    }
    const oldIndex = state.findIndex((i) => i.id === active.id)
    const newIndex = state.findIndex((i) => i.id === over.id)
    handlers.setState(arrayMove(state, oldIndex, newIndex))
  }

  return (
    <Box>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={state.map((i) => i.id)} strategy={verticalListSortingStrategy}>
          {state.map((item, index) => (
            <SortableItem key={item.id} item={item} index={index + 1} />
          ))}
        </SortableContext>
      </DndContext>
      <Group justify="flex-end" mt={40}>
        <Button size='xs' variant='default' onClick={quitAdjustPosition}>Cancel</Button>
        <Button size='xs' loading={loadingAdjust} onClick={() => handleSubmitAdjustImage(state)}>Update</Button>
      </Group>
    </Box>
  );
}

export default FormAdjustPositionImageProduct